import React from 'react';

const ErrorMessage = ({ message, onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-20 h-20 bg-status-error/10 rounded-full flex items-center justify-center mb-4">
        <svg className="w-10 h-10 text-status-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      
      <h3 className="text-xl font-bold text-neutral-textPrimary mb-2 font-heading">Đã xảy ra lỗi</h3>
      
      <p className="text-neutral-textSecondary text-center max-w-md mb-6 font-body">
        {message}
      </p>

      <button
        onClick={onRetry}
        className="px-6 py-3 bg-secondary-main text-white font-bold rounded-md-tqc hover:bg-secondary-dark transition-normal shadow-md-tqc hover:shadow-lg-tqc flex items-center space-x-2 font-body"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        <span>Thử lại</span>
      </button>

      <div className="mt-8 p-4 bg-neutral-bgDefault rounded-md-tqc border border-neutral-borderAccent">
        <p className="text-sm text-neutral-textSecondary text-center font-body">
          <strong>Gợi ý:</strong> Kiểm tra kết nối internet hoặc quét lại mã QR
        </p>
      </div>
    </div>
  );
};

export default ErrorMessage;
